"use client";

import apiFetch from "@/lib/fetch";
import { useEffect, useState } from "react";
import { DEFAULT_DATA_LIMIT } from "@/@core/constants/pagination";
import InfiniteScroll from "@/components/InfiniteScroll";
import LocationCard from "../../../venue-listing/locationCard/LocationCard";
import MapPinIcon from "@heroicons/react/24/solid/MapPinIcon";
import { Link } from "@/components/CustomLink";
import { Skeleton } from "@/components/ui/skeleton";
import { useSite } from "@/lib/hooks/site";

export default function FeaturedDistrictsClient({ initialData }) {
  const [isLoading, setIsLoading] = useState(true);
  const [featuredDistricts, setFeaturedDistricts] =
    useState<any[]>(initialData);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (initialData.length < DEFAULT_DATA_LIMIT) {
      setHasMore(false);
    }
    setIsLoading(false);
  }, [initialData]);

  const fetchData = async (index = 0) => {
    setIsLoading(true);
    const res = await apiFetch({
      route: `district/featured?index=${index}`,
    });

    if (res.length < DEFAULT_DATA_LIMIT) {
      setHasMore(false);
    }
    setIsLoading(false);

    return res;
  };

  const siteData = useSite();

  const next = (page: number) => {
    fetchData(page).then((data) => {
      setFeaturedDistricts([...featuredDistricts, ...data]);
    });
  };

  if (!Array.isArray(featuredDistricts) || !featuredDistricts) return <></>;

  if (!Array.isArray(featuredDistricts) || !featuredDistricts.length)
    return <></>;

  return (
    <>
      <InfiniteScroll
        hasMore={hasMore}
        next={next}
        loading={
          <>
            {Array.from(Array(16).keys()).map((index: number) => {
              return (
                <Skeleton
                    id="district-client-card-skeleton"
                  key={index}
                  className="w-full h-[42px] font-bold px-4 py-3 bg-gray-secondary rounded-2xl justify-start items-center gap-2 inline-flex"
                />
              );
            })}
          </>
        }
        isLoading={isLoading}
        skeletonElementId="district-client-card-skeleton"
        dataLength={featuredDistricts?.length || 0}
      >
        {featuredDistricts?.map((location: any) => {
          return (
            <Link
              title={location?.title}
              key={location.id}
              href={`/${location.slug}-${siteData.setting?.routes?.districtSpecificList}`}
              className="max-md:w-full"
            >
              <LocationCard icon={<MapPinIcon className="size-4" />} title={location.title} />
            </Link>
          );
        })}
      </InfiniteScroll>
    </>
  );
}
